import "date-fns";
import React, { useState } from "react";
import {
  Formik,
  FormikActions,
  Form as FormikForm,
  Field,
  FormikProps,
} from "formik";
import { InjectedIntlProps, injectIntl, FormattedMessage } from "react-intl";
import TextInput from "../../text-input";
import Typography from "../../typography";
import InputErrorMessage from "../../input-error-message";

import messages from "./NewMatchForm.intl";
import { styled, makeStyles, createStyles } from "@material-ui/styles";
import { IStyledArguments } from "../../../types/styled-arguments";
import { required } from "../../form-utils";
import { ITeam } from "../../../types";
import Select from "../../select";
import Option from "../../select/option";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import Button from "../../button";
import moment from "moment";
import {
  FormControlLabel,
  Switch,
  Theme,
  ButtonGroup,
} from "@material-ui/core";

export interface IFormValues {
  location: string;
  date: string;
  time: string;
  homeTeam: string;
  awayTeam: string;
  local: boolean;
  playersSelected: string[];
  playersConfirmed: string[];
  status: string;
}

const Title = styled(({ children }) => (
  <Typography.H5>{children}</Typography.H5>
))((props: IStyledArguments) => {
  const { md } = props.theme.breakpoints.values;

  return {
    marginBottom: 23,
    [`@media (max-width: ${md}px)`]: {
      marginBottom: 27,
    },
  };
});

const ImageHeader = styled("div")(({ theme }: IStyledArguments) => ({
  padding: theme.spacing(0, 1, 1, 1),
  width: "100%",
}));

const TeamsSelect = injectIntl<{
  onChange: (event: any) => void;
  value: any;
  teams: ITeam[];
  intl: InjectedIntlProps;
}>(({ onChange, value, teams, intl }) => {
  if (!teams || teams.length < 1) {
    return null;
  }
  return (
    <Select
      id="team-select"
      label={intl.formatMessage(messages.homeTeam)}
      value={value}
      onChange={onChange}
      fullWidth
    >
      <Option value="">
        <em>{"Select a Team"}</em>
      </Option>
      {teams.map(({ id, name }, idx: number) => (
        <Option key={idx} value={id}>
          {name}
        </Option>
      ))}
    </Select>
  );
});

interface IForm extends InjectedIntlProps {
  onSubmit: (arg: any) => void;
  location?: string;
  date?: string;
  time?: string;
  homeTeam?: any;
  awayTeam?: string;
  teams?: any;
  local?: boolean;
  playersSelected?: any;
  playersConfirmed?: any;
  status?: string;
  isHomeTeamLocal?: boolean;
}

const StyledForm = styled(FormikForm)(() => ({
  display: "flex",
  flexDirection: "column",
}));

const NewTeamForm = ({
  onSubmit,
  location = "",
  // date = "",
  // time = "",
  homeTeam = "",
  awayTeam = "",
  teams,
  isHomeTeamLocal = true,
  intl,
}: IForm) => {
  const [teamOption, setTeamOption] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date>(
    moment()
      .day("sunday")
      .isBefore(Date.now(), "day")
      ? moment()
          .day("sunday")
          .add(7, "day")
          .toDate()
      : moment()
          .day("sunday")
          .toDate()
  );
  const [selectedTime, setSelectedTime] = useState<Date>(
    new Date("2019-08-18T10:00:00")
  );

  const [local, setLocal] = useState<boolean>(true);
  const [friendly, setFriendly] = useState<boolean>(false);
  const [matchLocation, setMatchLocation] = useState<string>("buff");

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
  };
  const handleTimeChange = (date: Date) => {
    setSelectedTime(date);
  };

  const handleLocal = () => {
    console.log("previous local================");
    console.log(local);
    console.log("new local================");
    console.log(!local);
    setLocal(!local);
  };

  const handleFriendly = (isFriendly: boolean) => {
    console.log("friendly================");
    console.log(isFriendly);
    setFriendly(isFriendly);
  };

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& > *": {
          margin: theme.spacing(1),
        },
      },
    })
  );
  const classes = useStyles();
  return (
    <Formik
      initialValues={{
        location,
        date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
        time: `${moment(selectedTime).format("HH:mm")}`,
        homeTeam,
        awayTeam,
        teams,
        isHomeTeamLocal,
      }}
      onSubmit={(values: any, actions: FormikActions<any>) => {
        const toSubmit = { ...values };
        if (local && teams && teams.length === 1) {
          toSubmit.location = teams[0].location;
          toSubmit.homeTeam = teams[0].id;
        } else if (!local && teams && teams.length === 1) {
          toSubmit.homeTeam = teams[0].id;
        }
        console.log("========");
        console.log(toSubmit);
        console.log("========");
        onSubmit(toSubmit);
        actions.setSubmitting(false);
      }}
      render={({
        errors,
        touched,
        // values,
        isValid,
        setFieldValue,
      }: FormikProps<any>) => {
        return (
          <>
            <ImageHeader>
              <svg
                height="80px"
                viewBox="0 -60 512 512"
                width="80px"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <linearGradient
                  id="a"
                  gradientTransform="matrix(.323925 0 0 -.323925 0 443.462532)"
                  gradientUnits="userSpaceOnUse"
                  x1="297.4948"
                  x2="1283.1178"
                  y1="270.4995"
                  y2="1256.1224"
                >
                  <stop offset="0" stop-color="#41dfd0" />
                  <stop offset="1" stop-color="#ee83ef" />
                </linearGradient>
                <path
                  d="m239.378906 159.378906 16.210938 5.390625-25.597656 76.800781c-1.472657 4.476563-6.296876 6.914063-10.773438 5.441407-2.574219-.84375-4.59375-2.867188-5.441406-5.441407l-25.601563-76.800781 16.214844-5.390625 17.476563 52.511719zm59.289063 36.828125h-8.535157c-4.710937 0-8.53125-3.820312-8.53125-8.535156 0-4.710937 3.820313-8.53125 8.53125-8.53125h25.601563v-17.066406h-25.601563c-14.136718 0-25.601562 11.460937-25.601562 25.597656 0 14.140625 11.464844 25.601563 25.601562 25.601563h8.535157c4.710937 0 8.53125 3.820312 8.53125 8.535156 0 4.710937-3.820313 8.53125-8.53125 8.53125h-34.132813v17.066406h34.132813c14.136719 0 25.597656-11.460938 25.597656-25.597656 0-14.140625-11.460937-25.601563-25.597656-25.601563zm213.332031-59.734375v119.46875c0 4.710938-3.820312 8.53125-8.535156 8.53125h-100.476563c-37.648437 81.183594-133.976562 116.476563-215.160156 78.832032-34.777344-16.125-62.707031-44.058594-78.832031-78.832032h-18.6875c.511718 1.253906 1.007812 2.5625 1.554687 3.757813l-15.617187 6.882812c-1.199219-2.710937-2.339844-5.460937-3.414063-8.25l6.203125-2.390625h-70.5c-4.714844 0-8.535156-3.820312-8.535156-8.53125v-119.46875c0-4.710937 3.820312-8.53125 8.535156-8.53125h100.476563c37.636719-81.179687 133.953125-116.480468 215.132812-78.84375 34.78125 16.125 62.71875 44.058594 78.84375 78.84375h18.703125c-.46875-1.144531-.914062-2.296875-1.40625-3.414062l15.648438-6.828125c1.1875 2.707031 2.296875 5.453125 3.363281 8.226562l-5.25 2.015625h69.417969c4.714844 0 8.535156 3.820313 8.535156 8.53125zm-494.933594 51.199219h136.535156v-42.664063h-136.535156zm136.535156 59.734375v-42.664062h-136.535156v42.664062zm230.398438 17.066406h-34.132812c-4.714844 0-8.535157-3.820312-8.535157-8.53125v-119.46875c0-4.710937 3.820313-8.53125 8.535157-8.53125h34.132812c-37.703125-70.695312-125.574219-97.4375-196.265625-59.734375-25.398437 13.542969-46.191406 34.335938-59.734375 59.734375h34.132812c4.714844 0 8.535157 3.820313 8.535157 8.53125v119.46875c0 4.710938-3.820313 8.53125-8.535157 8.53125h-34.132812c37.703125 70.695313 125.574219 97.4375 196.265625 59.734375 25.398437-13.542969 46.191406-34.335937 59.734375-59.734375zm8.535156-119.464844h-34.136718v102.398438h34.136718zm51.199219 0h-34.132813v102.398438h34.132813zm51.199219 0h-34.132813v102.398438h34.132813zm-243.601563-145.007812c-2.988281.078125-5.972656.203125-8.910156.410156l1.152344 17.066406c2.699219-.1875 5.417969-.3125 8.160156-.375zm-77.753906 18.03125c-2.707031 1.261719-5.367187 2.558594-7.996094 3.925781l7.867188 15.144531c2.40625-1.246093 4.847656-2.449218 7.3125-3.582031zm95.570313-17.65625-1.152344 17.066406c2.734375.179688 5.4375.417969 8.132812.726563l1.90625-16.964844c-2.929687-.367187-5.882812-.632813-8.859375-.828125zm-119.023438 30.542969c-2.558594 1.609375-4.972656 3.285156-7.398438 5l9.867188 13.917969c2.207031-1.570313 4.457031-3.089844 6.75-4.558594zm171.386719-19.78125-5.71875 16.085937c2.558593.921875 5.121093 1.886719 7.679687 2.910156l6.433594-15.796874c-2.777344-1.125-5.574219-2.191407-8.394531-3.199219zm-245.566407 106.90625 15.652344 6.824219c1.089844-2.507813 2.230469-4.980469 3.414063-7.421876l-15.363281-7.5c-1.289063 2.65625-2.523438 5.355469-3.703126 8.097657zm296.628907 214.253906 11.09375 12.988281c2.269531-1.945312 4.480469-3.933594 6.65625-5.972656l-11.683594-12.445312c-1.972656 1.863281-3.996094 3.671874-6.066406 5.429687zm22.28125-249.371094c1.707031 2.101563 3.375 4.238281 5.007812 6.417969l13.703125-10.171875c-1.773437-2.394531-3.605468-4.742187-5.492187-7.046875zm-25.875-47.222656-9.8125 13.953125c2.21875 1.570312 4.386719 3.164062 6.519531 4.847656l10.523438-13.457031c-2.363282-1.832031-4.773438-3.613281-7.230469-5.34375zm-30.097657 319.429687c-2.394531 1.253907-4.835937 2.449219-7.292968 3.601563l7.21875 15.460937c2.695312-1.246093 5.359375-2.558593 7.996094-3.941406zm7.230469-333.328124-7.871093 15.144531c2.425781 1.257812 4.816406 2.566406 7.179687 3.925781l8.53125-14.789062c-2.585937-1.5-5.203125-2.929688-7.839844-4.28125zm-109.917969 352.519531-1.851562 16.964843c2.949219.324219 5.902344.585938 8.890625.773438l1.101563-17.066406c-2.742188-.136719-5.402344-.382813-8.140626-.671875zm59.5-370.347657-3.410156 16.71875c2.660156.542969 5.316406 1.140626 7.933594 1.816407l4.21875-16.539063c-2.898438-.738281-5.808594-1.40625-8.738281-2.003906v.007812zm-75.59375 367.828126c-2.671874-.535157-5.316406-1.140626-7.953124-1.800782l-4.148438 16.554688c2.882812.722656 5.789062 1.382812 8.710938 1.980468zm-21.523437-363.332032c-2.847656.855469-5.671875 1.808594-8.464844 2.800782l5.71875 16.085937c2.558594-.910156 5.144531-1.765625 7.757813-2.5625zm-94.863281 63.90625 13.234375 10.785156c1.707031-2.101562 3.476562-4.179687 5.308593-6.226562l-12.75-11.351562c-1.980468 2.230468-3.910156 4.496093-5.792968 6.792968zm36-12.527344-11.09375-12.988281c-2.273438 1.941407-4.492188 3.933594-6.652344 5.976563l11.664062 12.464844c1.988282-1.882813 4.019532-3.683594 6.082032-5.453126zm-51.453125 34.398438 14.566406 8.882812c1.421875-2.335937 2.890625-4.636718 4.410156-6.902343l-14.183593-9.480469c-1.644532 2.464844-3.257813 4.964844-4.792969 7.5zm136.402343-91.828125c-2.949218.488281-5.859374 1.015625-8.761718 1.613281l3.464844 16.71875c2.652343-.546875 5.332031-1.050781 8.027343-1.476562zm68.335938 369.164063c-2.644531.550781-5.316406 1.054687-8.011719 1.492187l2.738281 16.84375c2.953126-.476563 5.878907-1.03125 8.789063-1.636719zm-24.199219 3.410156c-2.695312.1875-5.417969.316406-8.160156.386718l.453125 17.066407c2.988281-.085938 5.972656-.214844 8.910156-.4375zm47.726563-10.023438c-2.558594.917969-5.140625 1.773438-7.742188 2.558594l5.011719 16.316406c2.84375-.878906 5.671875-1.820312 8.480469-2.824218zm111.511718-263.304687c-1.445312-2.601563-2.933593-5.160157-4.46875-7.683594l-14.566406 8.886719c1.414063 2.308594 2.777344 4.65625 4.085938 7.046875zm-293.910156 225.953125c-2-1.84375-3.9375-3.738282-5.847656-5.675782l-12.167969 11.945313c2.097657 2.136719 4.242188 4.210937 6.425781 6.230469zm255.894532-12.460938 12.714843 11.386719c2.007813-2.230469 3.933594-4.515625 5.8125-6.828125l-13.269531-10.734375c-1.707031 2.105469-3.460938 4.164063-5.257812 6.175781zm46.226562-41.171875-15.667969-6.765625c-1.085937 2.507813-2.222656 4.984375-3.414062 7.429688l15.359375 7.46875c1.292968-2.664063 2.53125-5.375 3.722656-8.132813zm-76.535156 68.378907c-2.203125 1.570312-4.449219 3.089843-6.742188 4.5625l9.25 14.355468c2.503906-1.621094 4.964844-3.292968 7.390625-5.019531zm45.226562-46.507813 14.199219 9.464844c1.644531-2.484375 3.257813-4.984375 4.796875-7.546875l-14.578125-8.8125c-1.414063 2.332031-2.878906 4.628906-4.394531 6.894531zm-306.261718 17.714844c1.773437 2.390625 3.625 4.746093 5.519531 7.039062l13.183593-10.828125c-1.703124-2.105468-3.378906-4.242187-5.015624-6.40625zm-14.507813-22.449219c1.445313 2.605469 2.941406 5.164062 4.488281 7.679688l14.550782-8.925782c-1.425782-2.3125-2.789063-4.660156-4.121094-7.050781zm293.984375-226.050781c1.984375 1.859375 3.929688 3.761719 5.835938 5.699219l12.203124-11.945313c-2.082031-2.128906-4.21875-4.203125-6.402343-6.230469zm-189.246094 297.355469-6.417968 15.8125c2.777343 1.136718 5.574218 2.195312 8.390624 3.171874l5.664063-16.101562c-2.574219-.90625-5.109375-1.851562-7.636719-2.882812zm-21.988281-10.695313-8.535156 14.796875c2.589843 1.484375 5.207031 2.90625 7.859375 4.269531l7.816406-15.164062c-2.398438-1.246094-4.796875-2.554688-7.140625-3.902344zm-13.757813-8.753906c-2.234374-1.570313-4.410156-3.191407-6.578124-4.855469l-10.417969 13.515625c2.34375 1.820313 4.75 3.585937 7.183593 5.292969zm0 0"
                  fill="url(#a)"
                />
              </svg>
            </ImageHeader>
            <Title>
              <FormattedMessage {...messages.title} />
            </Title>
            <div className={classes.root}>
              <Typography.Subtitle1>
                {intl.formatMessage(messages.homeAwayTitle)}
              </Typography.Subtitle1>
              <ButtonGroup
                size="large"
                color="primary"
                aria-label="large outlined primary button group"
              >
                <Button
                  color={local ? "primary" : "secondary"}
                  variant={local ? "contained" : "outlined"}
                  onClick={() => {
                    handleLocal();
                    setFieldValue("isHomeTeamLocal", !local);
                  }}
                >
                  {intl.formatMessage(messages.home)}
                </Button>
                <Button
                  color={local ? "primary" : "secondary"}
                  variant={local ? "outlined" : "contained"}
                  onClick={() => {
                    handleLocal();
                    setFieldValue("isHomeTeamLocal", !local);
                  }}
                >
                  {intl.formatMessage(messages.away)}
                </Button>
              </ButtonGroup>
            </div>

            <StyledForm data-testid="add-match-form">
              {/* {!local && ( */}
              {/* <> */}
              <Field
                name="location"
                // validate={required(intl)}
                error={errors.location && touched.location}
                component={TextInput}
                inputProps={{
                  "data-testid": "location",
                }}
                label={
                  local
                    ? teams && teams.length === 1
                      ? teams[0].location
                      : matchLocation
                    : intl.formatMessage(messages.location)
                }
                disabled={local ? true : false}
              />
              <InputErrorMessage name="location" />
              {/* </> */}
              {/* )} */}
              {teams && teams.length === 1 ? (
                <Field
                  name="homeTeam"
                  // validate={required(intl)}
                  error={errors.location && touched.location}
                  component={TextInput}
                  inputProps={{
                    "data-testid": "location",
                  }}
                  label={teams[0].name}
                  // value={0}
                  disabled
                />
              ) : (
                <>
                  <TeamsSelect
                    teams={teams}
                    value={teamOption}
                    onChange={(event: any) => {
                      console.log("********", event.target.value);
                      console.log("********", teams);
                      const selected = teams.filter(
                        (t: any) => t.id === event.target.value
                      )[0];
                      console.log("******* selected team ", selected);
                      setMatchLocation(selected.location);
                      setTeamOption(event.target.value);
                      setFieldValue("homeTeam", event.target.value);
                    }}
                  />
                  <InputErrorMessage name="homeTeam" />
                </>
              )}
              <Field
                name="awayTeam"
                validate={required(intl)}
                error={errors.awayTeam && touched.awayTeam}
                component={TextInput}
                inputProps={{
                  "data-testid": "awayTeam",
                }}
                label={intl.formatMessage(messages.awayTeam)}
              />
              <InputErrorMessage name="awayTeam" />

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label={intl.formatMessage(messages.date)}
                  format="yyyy-MM-dd"
                  value={selectedDate}
                  onChange={(date: any) => {
                    handleDateChange(date);
                    setFieldValue("date", moment(date).format("YYYY-MM-DD"));
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  margin="normal"
                  id="time-picker"
                  label={intl.formatMessage(messages.time)}
                  value={selectedTime}
                  ampm={false}
                  onChange={(time: any) => {
                    handleTimeChange(time);
                    setFieldValue("time", moment(time).format("HH:mm"));
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </MuiPickersUtilsProvider>
              {/* <FormControlLabel
                control={
                  // <Checkbox
                  //   name="isHomeTeamLocal"
                  //   checked={local}
                  //   onChange={(_, value: any) => {
                  //     console.log("========");
                  //     console.log(value);
                  //     // const isLocal: boolean = e.target.value;
                  //     handleLocal(value);
                  //     setFieldValue("isHomeTeamLocal", value);
                  //   }}
                  //   value={local}
                  // />
                  <Switch
                    checked={local}
                    onChange={(_, value: any) => {
                      console.log("========");
                      // console.log(value);
                      // // const isLocal: boolean = e.target.value;
                      // handleLocal(value);
                      setFieldValue("isHomeTeamLocal", value);
                    }}
                    name="isHomeTeamLocal"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                }
                label={intl.formatMessage(messages.isHomeTeam)}
              /> */}
              <FormControlLabel
                control={
                  <Switch
                    checked={friendly}
                    onChange={(_, value: any) => {
                      console.log("========");
                      console.log(value);
                      // const isLocal: boolean = e.target.value;
                      handleFriendly(value);
                      setFieldValue("isFriendly", value);
                    }}
                    name="isHomeTeamLocal"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                }
                label={intl.formatMessage(messages.friendly)}
              />
              <InputErrorMessage name="isHomeTeamLocal" />

              <div style={{ marginTop: 16 }}>
                <Button
                  color="primary"
                  size="medium"
                  type="submit"
                  data-testid="go-next-button"
                  disabled={!isValid}
                >
                  {intl.formatMessage(messages.next)}
                </Button>
              </div>
            </StyledForm>
          </>
        );
      }}
    />
  );
};

export default injectIntl(NewTeamForm);
